import identity from '@/mixins/identity';
import notification from '@/mixins/notification';
import http from '@/mixins/http';

export default {
  mixins: [identity, notification, http]
};
